Users = new (function () {
  this.setSelects = () => {
    let wrapper = $(".manage-users");
    if (!wrapper || !wrapper.length) return;

    $("#school_id", wrapper).select2({});

    $("#type", wrapper).select2({
      placeholder: "- Filter by user type -",
      minimumResultsForSearch: Infinity,
    });

    $("#logged", wrapper).select2({
      minimumResultsForSearch: Infinity,
      allowClear: false,
    });
  };

  this.initDeleteUserModal = () => {
    let wrapper = $(".manage-users");
    if (!wrapper || !wrapper.length) return;

    $(".confirm-delete input[name='confirm_delete_radiobox']").on("click", (e) => {
      $(".confirm-delete input[name='confirm_delete_checkbox']").prop("checked", $(e.currentTarget).val() == "true");
    });
  };

  this.initUserForm = () => {
    let wrapper = $(".user-form");
    if (!wrapper || !wrapper.length) return;

    $("#users_form_school_select", wrapper).select2({
      allowClear: false,
    });
  };

  this.bindEvents = () => {
    let wrapper = $(".user-form");
    if (!wrapper || !wrapper.length) return;

    if ($("#restore_teacher").data("restore-teacher")) {
      $("#restoreTeacherModal").modal("show");
    }
  };
})();
